module.exports = __webpack_public_path__ + "static/media/three_lady_eye_blink.85eb878b.gif";